import { IKeyValueInterface } from './../../shared/config';
import { AuthService } from './../../shared/models/auth.service';
import { TranslateService } from './../../shared/translate/translate.service';
import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { WeGoConfig, IAPIResponse, ApplicationRouteURL } from '../../shared/config';
import { Location } from '@angular/common';
import { CustomerService } from '../models/customer.service';
import { CustomerModel } from '../models/customer.model';

@Component({
  selector: 'wego-customer',
  template: require('../views/customer-update.component.html'),
  providers: [CustomerService],
})
export class CustomerUpdateComponent implements OnInit, OnDestroy {
  private customerHashId: string;
  private sub: any;
  private model: CustomerModel;
  private apiResponse: IAPIResponse;
  private errorModel: IKeyValueInterface[];
  private errorMessage: string;
  private message: string;
  private isEditMode: boolean;
  private popupMsg: string;
  private module: string;
  private breadCrumbTitle: string;
  private breadCrumbList: string;
  public searchField: string = "";
  public searchTerm: string = "";
  public selectedInstance: string = "";

  urlDefaultPage: string;
  urlCustomerList: string;

  @ViewChild('successPopup') public successPopup: any;

  constructor(private customerService: CustomerService,
    private translate: TranslateService,
    private activeRoute: ActivatedRoute,
    private authService: AuthService,
    private locationService: Location) {
  }

  ngOnInit() {
    this.module = this.translate.instant('LblCustomer');
    this.urlDefaultPage = this.authService.GetURL(ApplicationRouteURL.URL_DEFAULT_PAGE);
    this.urlCustomerList = this.authService.GetURL(ApplicationRouteURL.URL_CUSTOMER_LIST);
    this.isEditMode = false;
    this.model = new CustomerModel();
    this.GetCustomerDetails();
  }

  public GetCustomerDetails() {
    this.sub = this.activeRoute
      .params
      .subscribe(params => {
        this.customerHashId = params['id'] || '';
        if (this.customerHashId != '') {
          this.isEditMode = true;
          this.customerService.GetCustomerByHashId(this.customerHashId)
            .subscribe(
            res => {
              this.model = res.data;
            },
            error => {
              this.errorMessage = this.authService.HandleErrorStatusCode(error);
            });
        }
      });
    this.breadCrumbTitle = this.isEditMode ? this.translate.instant('LblEditPage', [this.module]) : this.translate.instant('LblAddPage', [this.module]);
    this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
  }

  public UpdateCustomer() {
    this.customerService.UpdateCustomer(this.model)
      .subscribe(
      res => {
        if (res.data) {
          this.popupMsg = this.isEditMode ? this.translate.instant('LblRecordUpdatedSuccess', [this.module]) : this.translate.instant('LblRecordAddedSuccess', [this.module]);
          this.ShowSuccessPopup();
        }
        else {
          this.errorModel = res.error;
        }
      },
      error => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
      });
  }

  public ShowSuccessPopup(): void {
    this.successPopup.show();
  }

  public HideSuccessPopup(): void {
    this.successPopup.hide();
    this.OnBackClick();
  }

  public ConfirmSuccessPopup(): void {
    this.successPopup.hide();
    this.OnBackClick();
  }

  public OnBackClick() {
    this.locationService.back();
  }

  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/customer/components/customer-update.component.ts